import { StockItem } from '@/interfaces/warehouse/StockItem'
import { StockMove } from '@/interfaces/warehouse/StockMove'

/** Pod touto hranicí dostupného množství považujeme zásobu za docházející. */
export const LOW_STOCK_THRESHOLD = 5

export type StockLevel = 'unlimited' | 'out' | 'low' | 'ok'

export const stockLevelOf = (item: Pick<StockItem, 'isUnlimited' | 'quantityAvailable'>): StockLevel => {
  if (item.isUnlimited) return 'unlimited'
  if (item.quantityAvailable <= 0) return 'out'
  if (item.quantityAvailable <= LOW_STOCK_THRESHOLD) return 'low'
  return 'ok'
}

export const stockLevelBadge: Record<Exclude<StockLevel, 'ok' | 'unlimited'>, { status: string; label: string }> = {
  out: { status: 'overdue', label: 'Vyprodáno' },
  low: { status: 'pending', label: 'Dochází' },
}

export const formatQuantity = (value: number) => value.toLocaleString('cs-CZ')

export const moveTypeLabel: Record<StockMove['type'], string> = {
  receipt: 'Příjem',
  issue: 'Výdej',
  adjustment: 'Úprava',
  transfer_in: 'Přesun sem',
  transfer_out: 'Přesun pryč',
}

/** Důvody úpravy stavu, ze kterých uživatel vybírá. Kód se ukládá do `reason`. */
export type AdjustReason = 'receipt' | 'return' | 'correction' | 'stocktake' | 'damage' | 'theft'

export interface AdjustReasonMeta {
  label: string
  /** Typ pohybu pro API */
  type: 'receipt' | 'issue' | 'adjustment'
  /**
   * add = kladné množství přibude, remove = ubude,
   * delta = zadává se změna se znaménkem, count = zadává se napočítaný stav
   */
  input: 'add' | 'remove' | 'delta' | 'count'
}

export const adjustReasons: Record<AdjustReason, AdjustReasonMeta> = {
  receipt: { label: 'Příjem zboží', type: 'receipt', input: 'add' },
  return: { label: 'Vrácení', type: 'receipt', input: 'add' },
  correction: { label: 'Korekce', type: 'adjustment', input: 'delta' },
  stocktake: { label: 'Inventura', type: 'adjustment', input: 'count' },
  damage: { label: 'Poškození', type: 'issue', input: 'remove' },
  theft: { label: 'Krádež', type: 'issue', input: 'remove' },
}

const systemReasonLabel: Record<string, string> = {
  opening_balance: 'Počáteční stav',
  sale: 'Prodej',
  sale_return: 'Vrácení z prodeje',
  transfer: 'Přesun mezi sklady',
}

export const reasonLabel = (reason?: string | null) => {
  if (!reason) return null
  if (reason in adjustReasons) return adjustReasons[reason as AdjustReason].label
  return systemReasonLabel[reason] ?? reason
}

export const formatMoveDate = (value?: string) => {
  if (!value) return '-'
  return new Date(value).toLocaleString('cs-CZ', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
